import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/gatePay',
    name: 'GatePay',
    component: () => import('@/views/gatePay/index.vue'),
    meta: { title: '岗亭停车缴费' }
  },
  {
    path: '/stationPay',
    name: 'StationPay',
    component: () => import('@/views/stationPay/index.vue'),
    meta: { title: '站内停车缴费' }
  },
  {
    path: '/payResult',
    name: 'PayResult',
    component: () => import('@/views/payResult/index.vue'),
    meta: { title: '支付结果' }
  },
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/home/index.vue'),
    meta: { title: '智慧停车' }
  },
  {
    path: '/carManage',
    name: 'CarManage',
    component: () => import('@/views/carManage/index.vue'),
    meta: { title: '车辆管理' }
  },
  {
    path: '/carManage/bindCar',
    name: 'BindCar',
    component: () => import('@/views/carManage/bindCar/index.vue'),
    meta: { title: '绑定车牌' }
  },
  {
    path: '/orderRecord',
    name: 'OrderRecord',
    component: () => import('@/views/orderRecord/index.vue'),
    meta: { title: '订单记录' }
  },
  {
    path: '/mine',
    name: 'Mine',
    component: () => import('@/views/mine/index.vue'),
    meta: { title: '我的' }
  },
  {
    path: '/mine/invoice',
    name: 'Invoice',
    component: () => import('@/views/mine/invoice/index.vue'),
    meta: { title: '电子发票' }
  },
  {
    path: '/mine/invoiceTitle',
    name: 'InvoiceTitle',
    component: () => import('@/views/mine/invoiceTitle/index.vue'),
    meta: { title: '抬头管理' }
  },
  {
    path: '/mine/invoiceApply',
    name: 'InvoiceApply',
    component: () => import('@/views/mine/invoiceApply/index.vue'),
    meta: { title: '申请发票' }
  },
  {
    path: '/mine/about',
    name: 'About',
    component: () => import('@/views/mine/about/index.vue'),
    meta: { title: '关于我们' }
  },
  {
    path: '/mine/agreement',
    name: 'Agreement',
    component: () => import('@/views/mine/agreement/index.vue'),
    meta: { title: '用户协议' }
  },
  {
    path: '/notice',
    name: 'NoticeList',
    component: () => import('@/views/notice/index.vue'),
    meta: { title: '系统公告' }
  },
  {
    path: '/notice/detail',
    name: 'NoticeDetail',
    component: () => import('@/views/notice/detail.vue'),
    meta: { title: '公告详情' }
  },
  {
    path: '/noPlateEntry',
    name: 'NoPlateEntry',
    component: () => import('@/views/noPlateEntry/index.vue'),
    meta: { title: '无牌车入场' }
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router
